import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const PrintContainer = styled.div`
  @media print {
    @page {
      size: 80mm auto;
      margin: 0;
    }
    body {
      margin: 0;
      padding: 10px;
    }
    * {
      box-sizing: border-box;
    }
    .no-print {
      display: none !important;
    }
  }

  @media screen {
    max-width: 300px;
    margin: 0 auto;
    padding: 20px;
    background: white;
    box-shadow: ${theme.shadows.lg};
  }
`;

const BillContent = styled.div`
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  color: #000;
  background: white;
  padding: 10px;

  @media print {
    padding: 5px;
  }
`;

const BillHeader = styled.div`
  text-align: center;
  border-bottom: 1px dashed #000;
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

const RestaurantName = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 5px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const RestaurantInfo = styled.div`
  font-size: 10px;
  margin: 3px 0;
  color: #333;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px dashed #000;
  margin: 10px 0;
`;

const BillDetails = styled.div`
  margin-bottom: 10px;
  font-size: 11px;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 3px 0;
`;

const ItemsSection = styled.div`
  margin: 10px 0;
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
  font-size: 11px;
`;

const ItemName = styled.span`
  flex: 1;
  margin-right: 10px;
`;

const ItemPrice = styled.span`
  font-weight: normal;
`;

const TotalsSection = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #000;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
  font-size: ${props => props.highlight ? '13px' : '11px'};
  font-weight: ${props => props.highlight ? 'bold' : 'normal'};
`;

const BillFooter = styled.div`
  text-align: center;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px dashed #000;
  font-size: 10px;
`;

function PrintableBill({ billData }) {
  if (!billData) return null;

  return (
    <PrintContainer>
      <BillContent>
        <BillHeader>
          <RestaurantName>HOTEL BATTASE SUKHSAGAR</RestaurantName>
          <RestaurantInfo>123 Main Street</RestaurantInfo>
          <RestaurantInfo>City, State - 123456</RestaurantInfo>
          <RestaurantInfo>Phone: +91-XXXXXXXXXX</RestaurantInfo>
          <RestaurantInfo>GSTIN: XXXXXXXXXXXXXX</RestaurantInfo>
        </BillHeader>

        <Divider />

        <BillDetails>
          <DetailRow>
            <span>Bill No:</span>
            <span>{billData.billNumber || 'N/A'}</span>
          </DetailRow>
          <DetailRow>
            <span>Date:</span>
            <span>{billData.date}</span>
          </DetailRow>
          <DetailRow>
            <span>Time:</span>
            <span>{billData.time}</span>
          </DetailRow>
          <DetailRow>
            <span>Table:</span>
            <span>{billData.tableNumber}</span>
          </DetailRow>
          <DetailRow>
            <span>Waiter:</span>
            <span>{billData.waiterName}</span>
          </DetailRow>
        </BillDetails>

        <Divider />

        <ItemsSection>
          {billData.items.map((item, index) => (
            <ItemRow key={index}>
              <ItemName>{item.quantity}x {item.name}</ItemName>
              <ItemPrice>₹{(item.price * item.quantity).toFixed(2)}</ItemPrice>
            </ItemRow>
          ))}
        </ItemsSection>

        <Divider />

        <TotalsSection>
          <TotalRow>
            <span>Subtotal:</span>
            <span>₹{billData.subtotal.toFixed(2)}</span>
          </TotalRow>
          <TotalRow>
            <span>GST (18%):</span>
            <span>₹{billData.gst.toFixed(2)}</span>
          </TotalRow>
          {billData.discount > 0 && (
            <TotalRow>
              <span>Discount:</span>
              <span>-₹{billData.discount.toFixed(2)}</span>
            </TotalRow>
          )}
          <TotalRow highlight>
            <span>Total:</span>
            <span>₹{billData.total.toFixed(2)}</span>
          </TotalRow>
        </TotalsSection>

        <BillFooter>
          <div>Thank you for visiting!</div>
          <div style={{ marginTop: '5px' }}>Visit us again</div>
        </BillFooter>
      </BillContent>
    </PrintContainer>
  );
}

export default PrintableBill;





